export type AvatarType = "default" | "wizard" | "warrior" | "sorceress";

export interface PlayerCustomization {
  name: string;
  color: number;
  avatarType: AvatarType;
}

export const COLORS: { hex: string; tint: number }[] = [
  { hex: "#a8c3f0", tint: 0xa8c3f0 },
  { hex: "#f0a89a", tint: 0xf0a89a },
  { hex: "#9ae0b8", tint: 0x9ae0b8 },
  { hex: "#f0d88a", tint: 0xf0d88a },
  { hex: "#c89af0", tint: 0xc89af0 },
  { hex: "#ffffff", tint: 0xffffff },
];

export const AVATAR_TYPES: { id: AvatarType; label: string }[] = [
  { id: "default", label: "Villager" },
  { id: "wizard", label: "Wizard" },
  { id: "warrior", label: "Warrior" },
  { id: "sorceress", label: "Sorceress" },
];

const STORAGE_KEY = "mythglade_customization";

export function loadCustomization(): PlayerCustomization {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return {
        name: String(parsed.name || "").slice(0, 16),
        color: typeof parsed.color === "number" ? parsed.color : COLORS[0]!.tint,
        avatarType: AVATAR_TYPES.some((a) => a.id === parsed.avatarType) ? parsed.avatarType : "default",
      };
    }
  } catch { /* ignore */ }
  return { name: "", color: COLORS[0]!.tint, avatarType: "default" };
}

export function saveCustomization(c: PlayerCustomization): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(c));
}
